import ApplicationController from './application_controller';
import log from '../lib/logger';

export default class extends ApplicationController {
  static targets = ['animationContainer'];

  // Note: no connect() init here. animationContainerTargetConnected fires for
  // targets already present at connection time as well as lazily-added ones,
  // so a connect() call would double-initialize the animation.
  animationContainerTargetConnected() {
    // This will be called when the animation container element is added to the DOM
    this.initializeAnimation();
  }

  animationContainerTargetDisconnected() {
    // Invalidate any init still awaiting its dynamic import
    this.animationGeneration = (this.animationGeneration || 0) + 1;
    this.teardownAnimation();
  }

  initializeAnimation() {
    // Tear down any previous run before starting a new one
    this.teardownAnimation();
    this.animationGeneration = (this.animationGeneration || 0) + 1;
    const generation = this.animationGeneration;

    // Import and initialize the payment method history animation module
    import('../pages/payment_method_history_animation')
      .then((module) => {
        // Bail if the target disconnected (or re-initialized) while the import was in flight
        if (generation !== this.animationGeneration || !this.hasAnimationContainerTarget) return;

        const initAnimation = module.default;
        if (initAnimation !== undefined) {
          // Get history data from the data attribute
          let historyData = [];
          try {
            const dataAttr = this.animationContainerTarget.dataset.historyData;
            if (dataAttr && dataAttr !== 'undefined') {
              historyData = JSON.parse(dataAttr);
            }
          } catch (e) {
            log.error('Error parsing history data:', e);
            historyData = [];
          }

          const { patientId } = this.animationContainerTarget.dataset;

          // Initialize the animation and keep its cleanup function (removes the
          // window resize listener, stops timers, disposes tooltips)
          this.animationCleanup = initAnimation(historyData, patientId);
        }
      })
      .catch((error) => {
        log.error('Error loading payment method history animation:', error);
      });
  }

  teardownAnimation() {
    if (typeof this.animationCleanup === 'function') {
      this.animationCleanup();
    }
    this.animationCleanup = null;
  }

  // Action methods for controls
  play() {
    if (window.paymentMethodAnimation && window.paymentMethodAnimation.play) {
      window.paymentMethodAnimation.play();
    }
  }

  pause() {
    if (window.paymentMethodAnimation && window.paymentMethodAnimation.pause) {
      window.paymentMethodAnimation.pause();
    }
  }

  reset() {
    if (window.paymentMethodAnimation && window.paymentMethodAnimation.reset) {
      window.paymentMethodAnimation.reset();
    }
  }

  stepForward() {
    if (window.paymentMethodAnimation && window.paymentMethodAnimation.stepForward) {
      window.paymentMethodAnimation.stepForward();
    }
  }

  stepBackward() {
    if (window.paymentMethodAnimation && window.paymentMethodAnimation.stepBackward) {
      window.paymentMethodAnimation.stepBackward();
    }
  }
}
